<template>
  <section id="service" class="n2-seccion n3-servicios" v-if="S?.Mostrar && servicios.length">
    <div class="n2-contenedor n2-cabeza-seccion n2-cabeza-seccion--fila n2-aparece">
      <div>
        <h2 class="n2-titulo-seccion"><NuxtLink :to="getLocalePath('/servicios')"><span v-html="S.Titulo?.Texto || tituloSeccion(NOTARIA, 'Servicios', $t)"></span></NuxtLink></h2>
        <div v-if="S.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(S.Descripcion.css)" v-html="S.Descripcion.Texto"></div>
      </div>
      <div class="n3-flechas">
        <button type="button" class="n3-flecha" aria-label="Anterior" @click="mover(-1)"><v-icon>mdi-arrow-left</v-icon></button>
        <button type="button" class="n3-flecha" aria-label="Siguiente" @click="mover(1)"><v-icon>mdi-arrow-right</v-icon></button>
      </div>
    </div>

    <!-- Carrusel a sangre: se desliza con el dedo, la rueda o las flechas.
         Toda la tarjeta abre el servicio (el enlace "Más información" la cubre), salvo si se estaba arrastrando -->
    <div ref="pista" class="n3-carrusel" tabindex="0" :aria-label="S.Titulo?.Texto ? textoPlano(S.Titulo.Texto) : 'Servicios'"
      @pointerdown="inicioToque" @click.capture="evitarClicTrasArrastre">
      <article v-for="(s, i) in servicios" :key="s.id ?? i" class="n3-servicio" :class="{ 'n3-servicio--sin-foto': !s.Imagen }">
        <img v-if="s.Imagen" :src="imagenIDtoSRC(s.Imagen)" :alt="s.Titulo" loading="lazy" />
        <span class="n3-servicio__num">{{ String(i + 1).padStart(2, '0') }}</span>
        <div class="n3-servicio__cuerpo">
          <h3>{{ s.Titulo }}</h3>
          <p>{{ textoPlano(s.Extracto || s.Subtitulo || s.Contenido, 120) }}</p>
          <div class="n3-servicio__acciones">
            <NuxtLink :to="getLocalePath('/servicios/' + s.Slug) + '?from=home'" class="n3-servicio__mas">{{ tSolicitud('Más información') }} →</NuxtLink>
            <NuxtLink v-if="acceso.visible('servicios') && acceso.tramiteDeServicio(s)" :to="acceso.enlace('servicios', acceso.tramiteDeServicio(s))"
              class="n2-boton n2-boton--acento">{{ tSolicitud('Hacerlo online') }}</NuxtLink>
          </div>
        </div>
      </article>
    </div>

    <div v-if="S.ShowButton && S.Button?.Texto" class="n2-centrado">
      <NuxtLink class="n2-boton n2-boton--linea" :to="getLocalePath('/servicios')">{{ S.Button.Texto }}</NuxtLink>
    </div>
  </section>
</template>

<script setup>
import { ref, computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, alineacionTexto } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const acceso = useAccesoSolicitud()

// Panel: Inicio → Servicios y los servicios marcados "Mostrar en inicio"
const S = computed(() => NOTARIA.value?.Theme?.Home?.Servicios)
const servicios = computed(() => (NOTARIA.value?.Servicios ?? []).filter(s => s.Publicado && s.MostrarHome))

const pista = ref(null)
function mover(sentido) {
  const el = pista.value
  if (!el) return
  const tarjeta = el.querySelector('.n3-servicio')
  el.scrollBy({ left: sentido * ((tarjeta?.offsetWidth ?? 320) + 20), behavior: 'smooth' })
}

// Un arrastre del carrusel no debe abrir el servicio de la tarjeta donde empezó (ref: https://trello.com/c/RqWuSORa)
let toque = null
function inicioToque(e) { toque = { x: e.clientX, y: e.clientY } }
function evitarClicTrasArrastre(e) {
  if (toque && Math.hypot(e.clientX - toque.x, e.clientY - toque.y) > 8) { e.preventDefault(); e.stopPropagation() }
  toque = null
}
</script>
